"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabModern = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../../helpers");
const TabModern_styles_1 = require("./TabModern.styles");
exports.TabModern = (0, helpers_1.createUIElement)('TabModern', (_a, ref) => {
    var { className, id, active, disabled, completed, truncate = false, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "id", "active", "disabled", "completed", "truncate", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const icon = (0, react_1.useMemo)(() => {
        if (completed) {
            return (react_1.default.createElement(TabModern_styles_1.StyledTabModernIcon, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
                react_1.default.createElement("path", { d: "M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1ZM12.8977 7.2727L8.875 11.2954L7.1023 9.5227C6.83869 9.2591 6.41131 9.2591 6.1477 9.5227C5.8841 9.78631 5.8841 10.2137 6.1477 10.4773L8.3977 12.7273C8.66131 12.9909 9.08869 12.9909 9.3523 12.7273L13.8523 8.2273C14.1159 7.96369 14.1159 7.53631 13.8523 7.2727C13.5887 7.0091 13.1613 7.0091 12.8977 7.2727Z", fill: "#00B44D" })));
        }
        if (active) {
            return (react_1.default.createElement(TabModern_styles_1.StyledTabModernIcon, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
                react_1.default.createElement("path", { id: "Shape", d: "M10.8371 3.13074C10.6332 2.94456 10.3169 2.95895 10.1307 3.16289C9.94456 3.36683 9.95895 3.68309 10.1629 3.86927L16.3307 9.5H2.5C2.22386 9.5 2 9.72386 2 10C2 10.2761 2.22386 10.5 2.5 10.5H16.3279L10.1629 16.1281C9.95895 16.3143 9.94456 16.6305 10.1307 16.8345C10.3169 17.0384 10.6332 17.0528 10.8371 16.8666L17.7535 10.5526C17.8934 10.4248 17.9732 10.2573 17.993 10.0841C17.9976 10.0568 18 10.0287 18 10C18 9.97313 17.9979 9.94675 17.9938 9.92103C17.9756 9.74512 17.8955 9.57446 17.7535 9.44478L10.8371 3.13074Z", fill: "currentColor" })));
        }
        return (react_1.default.createElement(TabModern_styles_1.StyledTabModernIcon, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
            react_1.default.createElement("circle", { id: "placeholder_circle", cx: "10", cy: "10", r: "8.5", stroke: "currentColor" })));
    }, [active, completed]);
    return (react_1.default.createElement(TabModern_styles_1.StyledTabModern, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": initialDataSelectorId, id: id, active: active, isDisabled: disabled, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, type: "button", className: className }),
        icon,
        react_1.default.createElement(TabModern_styles_1.StyledTabModernText, { asTag: 'span', truncate: truncate }, children)));
});
//# sourceMappingURL=TabModern.js.map